import { useState } from 'react';
import deleteIcon from '../../../../../../../assets/images/delete_forever.png';

export const DraggableEvent = ({
    data,
    toGetAssetInfo,
    item,
    locationState,
    index,
    calculateMinutes,
    zoomInOut,
    newGridData,
    key,
    formatTime,
    programDelete,
    viewType,
    assetInfo,
    weeklyView,
    isPublished,
    editableTime
}) => {
    const [hoverSide, setHoverSide] = useState(null);
    return (
        <tr
            className="dragabble"
            onClick={() => {
                if (weeklyView || locationState?.state?.channelAssembly === "EXTERNAL") {
                    return
                } else {
                    if (viewType === "expandView") {
                        toGetAssetInfo(index)
                    } else {
                        toGetAssetInfo(data?.sequence, item?.date, data?.isSplit)
                    }
                }
            }}
            draggable={locationState?.state?.permission === "edit" && !(locationState?.state?.channelAssembly === "EXTERNAL") && !weeklyView ? true : false}
            // draggable={true}
            data-type="draggable-list"
            key={`${index}`}
            data-value={JSON.stringify({date:item.date, ...data})}
            data-id={data?.sequence}
            style={{
                height: `${calculateMinutes(
                    data?.totalDuration
                    ? data?.totalDuration
                    : data?.durationInMillis +
                        (data?.adBreaks?.reduce((sum, ad) => sum + ad.durationInMillis, 0) || 0)
                ) * zoomInOut}px`,
                // width: "13vw", // Set width relative to the viewport width
                // width: viewType === "expandView" ? "20rem" : "11rem", // Set width relative to the viewport width
                width: `${weeklyView? "100%" : "95%"}`, // Set width relative to the viewport width
                // position: "absolute",
                position: "relative",
                left: `${weeklyView? "0" : viewType === "expandView"? "6%" : "9%"}`, // Adjust left position relative to the viewport width
                overflow: "hidden",
                transition: "height 0.3s ease-in-out",
                border: assetInfo?.sequence === data?.sequence ? "1px solid transparent" : "",
                borderImage: assetInfo?.sequence === data?.sequence ? "linear-gradient(to right, #22bbbe, #7dad41, #f4b719, #e55824, #b52c80) 1" : ""
                }}
            title={data?.title}
        >
            <td data-id={data?.sequence} data-checkissplit={data?.isSplit} data-ifdate={data?.isSplit && newGridData[key - 1]?.date} 
            style={{ 
                background: index % 4 === 0 ? "#FFC374" : index % 4 === 1 ? "#4AD2C9" : index % 4 === 2 ? "#8E73EF" : "#536EFF" ,
                border: assetInfo?.sequence === data?.sequence ? "4px solid rgba(0, 0, 0, 0.9)" : ""
                }}>
                {
                    data?.isSplit &&
                    <div class="dots position-absolute d-flex align-items-end mx-2 pe-none" style={{height: `15px`}}>
                        {[...Array(viewType === "expandView"? 18: 10)].map((_, index) => (
                            <div key={index} className="dot"></div>
                        ))}
                    </div>
                }
                <div className="table-content2" style={{ background: "rgba(255, 255, 255, 0.25)", pointerEvents: "none"}}>
                    <div className="title-schedule-container" style={{width: "70%"}}> 
                        <p 
                            className={`${weeklyView? "ps-1" : "px-2"} fw-bold m-0 program-title`} 
                            style={{
                                color: "#212529",
                                fontSize: `${weeklyView ? "9.88px": ""}`
                            }}
                        >
                            {data?.title}
                        </p>
                        <p 
                            className={`${weeklyView? "ps-1" : "px-2"} fw-bold schedule-time`} 
                            style={{
                                color: "#212529",
                                fontSize: `${weeklyView ? "8.24px" : "11px"}`
                            }}
                        >
                            {`${formatTime(data?.startAt)} -  ${formatTime(data?.endAt)}`}
                        </p>
                    </div>
                    <div className="position-relative">
                        {
                            locationState?.state?.channelAssembly === "EXTERNAL"?
                            ""
                            :
                            <>
                                {
                                    data?.isSplit === true || weeklyView || (isPublished && editableTime >= data?.startAt) ? 
                                    ''
                                    :
                                    <a className="p-2 table-icon position-absolute" onClick={(e) => {programDelete(e, data?.uuid, item?.date)}} style={{filter: "invert(0)", pointerEvents: "auto", zIndex: "99999"}}>
                                        <img src={deleteIcon} width={18} />
                                    </a>
                                }
                                {
                                    weeklyView ?
                                    <a className="p-2 position-absolute table-adbreaks-count-weekly" style={{filter: "invert(0)", pointerEvents: "auto", right: "0px"}}>
                                        <span>{data?.adBreaks.length}</span>
                                    </a>
                                    :
                                    <a className="p-2 table-adbreaks-count position-absolute" style={{filter: "invert(0)", pointerEvents: "auto"}}>
                                        <span>{data?.adBreaks.length}</span>
                                    </a>
                                }
                            </>
                        }
                    </div>
                </div>
                {
                    data?.lastSplitItem &&
                    <div class="dots position-relative d-flex align-items-end mx-2 pe-none" style={{height: `${calculateMinutes(
                    data?.totalDuration
                        ? data?.totalDuration
                        : data?.durationInMillis +
                        (data?.adBreaks?.reduce((sum, ad) => sum + ad.durationInMillis, 0) || 0)
                    ) * zoomInOut - 27}px`}}>
                        {[...Array(viewType === "expandView"? 20: 10)].map((_, index) => (
                            <div key={index} className="dot"></div>
                        ))}
                    </div>
                }
            </td>
        </tr>
    )
}